import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import axios from "api/axios";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";
import PageShell, { SectionCard } from "components/patch/PageShell";
import SimpleTable from "components/patch/SimpleTable";

export default function EmployeeList() {
  const [rows, setRows] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/staff", {
        params: { search: query || undefined },
      });

      const payload = res.data?.data || res.data || [];
      const normalized = Array.isArray(payload)
        ? payload.map((item) => ({
            pf_no: item.pf_no || item.pfno || "-",
            surname: item.surname || item.biodata?.surname || "-",
            firstname: item.firstname || item.biodata?.firstname || "-",
            salary_structure: item.salary_structure || "-",
            grade_level: item.grade_level || "-",
            step: item.step || "-",
          }))
        : [];

      setRows(normalized);
    } catch (error) {
      console.error("Failed to load employees:", error);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <PageShell title="Employee List" subtitle="Search and review the payroll employee register.">
      <SectionCard title="Search Employees" subtitle="Find staff by PF number or name.">
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={8}>
            <MDInput
              label="Search by PF No / Name"
              fullWidth
              value={query}
              onChange={(e) => setQuery(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <MDButton variant="gradient" color="error" fullWidth onClick={load} disabled={loading}>
              {loading ? "Loading..." : "Load Employees"}
            </MDButton>
          </Grid>
        </Grid>
      </SectionCard>

      <MDBox mt={3}>
        <SectionCard title="Employee Register">
          <SimpleTable
            columns={[
              { key: "pf_no", label: "PF No" },
              { key: "surname", label: "Surname" },
              { key: "firstname", label: "First Name" },
              { key: "salary_structure", label: "Salary Structure" },
              { key: "grade_level", label: "Grade" },
              { key: "step", label: "Step" },
            ]}
            rows={rows}
          />
        </SectionCard>
      </MDBox>
    </PageShell>
  );
}
